import FlashMessages from 'Components/Flash/Messages';
import SnapchatPixel from 'Components/SnapchatPixel';
import tree from '_assets/img/colored-tree.png';
import { SNAPCHAT_PIXEL_ID } from '_constants/snapchatPixel';
import Cookies from 'js-cookie';
import { ReactNode, useEffect } from 'react';
import BaseLayout from '../Base';
import './style.scss';

type GuestLayoutProps = {
    children: ReactNode;
    showImage?: boolean;
    showLogo?: boolean;
    showBackButton?: boolean;
    showClose?: boolean;
    classes?: string;
};

const GuestLayout = ({
    children,
    showImage = true,
    showLogo = true,
    showBackButton = true,
    showClose = true,
    classes,
}: GuestLayoutProps): React.JSX.Element => {
    /**
     * Checks if an invited_by param is available in the url.
     * If it is, it sets the invited_by cookie to the param value
     */
    const saveInvitedBy = () => {
        const urlSearchParams = new URLSearchParams(window.location.search),
            params = Object.fromEntries(urlSearchParams.entries()),
            invitedBy = params.invited_by ?? null;

        if (invitedBy) {
            Cookies.set('invited_by', invitedBy);
        }
    };

    useEffect(() => saveInvitedBy(), []);

    /**
     * Effect for initializing snapchat pixel and sending page view
     */
    useEffect(() => {
        SnapchatPixel.init(SNAPCHAT_PIXEL_ID);
        SnapchatPixel.pageView();
    }, []);

    return (
        <BaseLayout
            classes={`guest-layout ${classes ?? ''}`}
            showLogo={showLogo}
            showClose={showClose}
            showBackButton={showBackButton}
        >
            <>
                {showImage && (
                    <img className="kan-tree" src={tree} alt="Knit&Note Tree" />
                )}

                <FlashMessages />

                {children}
            </>
        </BaseLayout>
    );
};

export default GuestLayout;
